import { render } from "./StudentAssistant.vue?vue&type=template&id=05de1cc9"
import script from "./StudentAssistant.vue?vue&type=script&lang=js"
export * from "./StudentAssistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__